import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/ui/Icon';
import { ICONS } from '@/constants/icons';

interface BulkImportStartWarningsProps {
  /** Row texts from the server (e.g. "Row 4: image skipped, storage limit reached"), shown as received */
  warnings: string[];
}

/**
 * Non-blocking notes returned when an import starts. Renders nothing without warnings and never gets in
 * the way of the progress / result views below it.
 */
export const BulkImportStartWarnings = ({ warnings }: BulkImportStartWarningsProps) => {
  const { t } = useTranslation('common');
  if (warnings.length === 0) return null;

  return (
    <div
      role="status"
      data-testid="bulk-import-start-warnings"
      className="mb-4 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3"
    >
      <p className="flex items-center gap-2 text-sm font-semibold text-amber-900">
        <Icon name={ICONS.WARNING} size="sm" color="text-amber-600" ariaHidden />
        {t('bulk_import_start_warnings_title', { count: warnings.length })}
      </p>
      <ul className="mt-2 list-disc space-y-1 pl-6 text-xs text-amber-800 break-words">
        {warnings.map((warning, index) => (
          <li key={`${index}-${warning}`}>{warning}</li>
        ))}
      </ul>
    </div>
  );
};

export default BulkImportStartWarnings;
